import { Col, Input, Label, Row } from "reactstrap";
import { dateConversion } from "../../../../../utils/dateUtils";
import { ChangeEvent } from "react";
import { Btn } from "../../../../../AbstractElements";
import { CheckboxAttendanceRequest } from "../../types";

export interface ITeamMembersAttendanceBulkApprovedFormProps {
  selectAllAttendanceRequest: boolean;
  allTeamAttendanceRequests: CheckboxAttendanceRequest[];
  checkboxTeamAttendanceRequest: CheckboxAttendanceRequest[];
  searchEmployeeAttendanceRequest: (e: ChangeEvent<HTMLInputElement>) => void;
  onSelectAllAttendanceRequest: (e: ChangeEvent<HTMLInputElement>) => void;
  sortEmployeeAttendanceRequestList: (
    a: CheckboxAttendanceRequest,
    b: CheckboxAttendanceRequest
  ) => number;
  onCheckboxAttendanceRequest: (
    e: ChangeEvent<HTMLInputElement>,
    item: CheckboxAttendanceRequest
  ) => void;
  onBulkAttendance: (action: "approved" | "rejected") => void;
}

const TeamMembersAttendanceBulkApprovedForm = ({
  onBulkAttendance,
  onCheckboxAttendanceRequest,
  sortEmployeeAttendanceRequestList,
  allTeamAttendanceRequests,
  checkboxTeamAttendanceRequest,
  selectAllAttendanceRequest,
  onSelectAllAttendanceRequest,
  searchEmployeeAttendanceRequest,
}: ITeamMembersAttendanceBulkApprovedFormProps) => {
  return (
    <div>
      <Row className="align-items-center mb-3">
        <Col xs="8" className="pe-0">
          <Input
            type="search"
            onChange={searchEmployeeAttendanceRequest}
            placeholder="Search Employee"
          />
        </Col>
        <Col xs="3">
          <Label className="d-flex text-nowrap f-12">
            <Input
              className="checkbox_animated"
              type="checkbox"
              name="userStatus"
              // value={d}
              checked={selectAllAttendanceRequest}
              onChange={onSelectAllAttendanceRequest}
            />
            Select All
          </Label>
        </Col>
      </Row>
      <Row>
        <Label>
          Selected Attendance Request:{" "}
          {
            allTeamAttendanceRequests?.filter(
              (d: CheckboxAttendanceRequest) => d.isChecked
            )?.length
          }
        </Label>
      </Row>
      <div
        className="px-2"
        style={{ height: "300px", maxHeight: "300px", overflow: "auto" }}
      >
        {checkboxTeamAttendanceRequest &&
          checkboxTeamAttendanceRequest &&
          Array.isArray(checkboxTeamAttendanceRequest) &&
          checkboxTeamAttendanceRequest.length > 0 &&
          checkboxTeamAttendanceRequest
            ?.sort(sortEmployeeAttendanceRequestList)
            .map((d: CheckboxAttendanceRequest) => {
              return (
                <div>
                  <Label className="d-block my-3 f-12" key={d.team_member.id}>
                    <Input
                      id={String(d.team_member.id)}
                      className="checkbox_animated"
                      type="checkbox"
                      name="userStatus"
                      value={String(d.attendance_request_id)}
                      checked={d.isChecked}
                      onChange={(e) => onCheckboxAttendanceRequest(e, d)}
                    />
                    {d.team_member.name}: {dateConversion(d.date)}{" "}
                  </Label>
                </div>
              );
            })}
      </div>
      <div className="w-100 d-flex justify-content-center mt-3">
        <Btn color="primary" onClick={() => onBulkAttendance("approved")}>
          Approve
        </Btn>
        <Btn color="danger ms-3" onClick={() => onBulkAttendance("rejected")}>
          Rejected
        </Btn>
      </div>
    </div>
  );
};

export default TeamMembersAttendanceBulkApprovedForm;
